export function clipSvgWidth(svg: SVGElement, start: number, stop: number) {
  // Clone the SVG to avoid modifying the original
  const svgClone = svg.cloneNode(true) as SVGElement;

  // Get original SVG dimensions
  const originalHeight = parseFloat(svgClone.getAttribute("height") || "0");

  // Calculate the range width
  const rangeWidth = stop - start;

  // Create a clipPath to hide content outside the range
  const defs = document.createElementNS("http://www.w3.org/2000/svg", "defs");
  const clipPath = document.createElementNS("http://www.w3.org/2000/svg", "clipPath");
  const rect = document.createElementNS("http://www.w3.org/2000/svg", "rect");

  clipPath.setAttribute("id", "rangeClip");
  rect.setAttribute("x", start.toString());
  rect.setAttribute("y", "0");
  rect.setAttribute("width", rangeWidth.toString());
  rect.setAttribute("height", originalHeight.toString());

  clipPath.appendChild(rect);
  defs.appendChild(clipPath);
  svgClone.insertBefore(defs, svgClone.firstChild);

  // Apply the clip path to the main group
  const mainGroup = svgClone.querySelector("g");
  if (mainGroup) {
    mainGroup.setAttribute("clip-path", "url(#rangeClip)");
  }

  // Set viewBox to focus on the range and adjust SVG dimensions
  svgClone.setAttribute("viewBox", `${start} 0 ${rangeWidth} ${originalHeight}`);
  svgClone.setAttribute("width", rangeWidth.toString());
  svgClone.setAttribute("height", originalHeight.toString());

  return { svgClone, rangeWidth, originalHeight };
}
